import {
	GET_BRAND_DATA,
	GET_BRAND_ERROR,
	GET_BRAND_SUCCESS,
	GET_PRODUCT_DATA,
	GET_MORE_PRODUCT_DATA,
	GET_PRODUCT_ERROR,
	GET_PRODUCT_SUCCESS,
	GET_COMPARE_SUCCESS
} from 'constants/compareConstants';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import get from 'lodash/get';

export function compareBrandReducer(
	state = {
		asyncStatus: INIT
	},
	action = null
) {
	switch (action.type) {
		case GET_BRAND_DATA:
			return Object.assign({}, state, { asyncStatus: LOADING });
		case GET_BRAND_SUCCESS:
			return Object.assign({}, state, { asyncStatus: SUCCESS, ...action.data });
		case GET_BRAND_ERROR:
			return Object.assign({}, state, { asyncStatus: ERROR, error: action.error });
		default:
			return state;
	}
}

export function compareAddProductReducer(
	state = {
		asyncStatus: INIT,
		brandvsproduct: {},
		brand: null
	},
	action = null
) {
	switch (action.type) {
		case GET_PRODUCT_DATA:
			return Object.assign({}, state, { asyncStatus: LOADING, brand: action.brand });
		case GET_MORE_PRODUCT_DATA:
			return Object.assign({}, state, { asyncStatus: 'LOADING_MORE', brand: action.brand });
		case GET_COMPARE_SUCCESS:
			const nbrandvsproduct = Object.assign({}, state.brandvsproduct);
			const pids = action.pids;
			if (state.brand && nbrandvsproduct[state.brand] && pids && pids.length) {
				const productData = get(nbrandvsproduct[state.brand], ['data', 'product_listview', 'fullData']);
				const fullData = productData.slice();
				pids.forEach(pid => {
					const productList = productData.map(product => get(product, ['value', 'id']));
					const pidIndex = productList.indexOf(pid);
					if (pidIndex > -1) {
						productData.splice(pidIndex, 1);
					}
				});
				nbrandvsproduct[state.brand].data.product_listview.data = productData;
				nbrandvsproduct[state.brand].data.product_listview.fullData = fullData;
			}
			return state;
		case GET_PRODUCT_SUCCESS:
			const brandvsproduct = Object.assign({}, state.brandvsproduct);
			brandvsproduct[action.brand] = getProductData(
				brandvsproduct[action.brand],
				action.data,
				action.vertical,
				action.productList
			);
			return Object.assign({}, state, { asyncStatus: SUCCESS, brandvsproduct, brand: action.brand });
		case GET_PRODUCT_ERROR:
			return Object.assign({}, state, { asyncStatus: ERROR, error: action.error, brand: action.brand });
		default:
			return state;
	}
}

function getProductData(oldData, newData, vertical, compareList) {
	const compareIds =
		(compareList && compareList.length && compareList.map(product => get(product, ['value', 'id']))) || [];
	const newProductData = get(newData, ['data', 'product_listview', 'data']);
	if (oldData) {
		let productData = get(oldData, ['data', 'product_listview', 'data']);
		let fullData = get(oldData, ['data', 'product_listview', 'fullData']);
		const productList = productData.map(product => get(product, ['value', 'id']));
		const fullProductList = fullData.map(product => get(product, ['value', 'id']));
		if (productData && productData.length > 0 && newProductData) {
			newProductData.forEach(newProduct => {
				const newProductId = get(newProduct, ['value', 'id']);
				if (productList.indexOf(newProductId) === -1 && compareIds.indexOf(newProductId) === -1) {
					productData = productData.concat(newProduct);
				}
				if (fullProductList.indexOf(newProductId) === -1) {
					fullData = fullData.concat(newProduct);
				}
			});
			oldData.data.product_listview.data = productData;
			oldData.data.product_listview.fullData = fullData;
		}
		return oldData;
	}
	let productData = [];
	if (newProductData) {
		newProductData.forEach(newProduct => {
			const newProductId = get(newProduct, ['value', 'id']);
			if (compareIds.indexOf(newProductId) === -1) {
				productData = productData.concat(newProduct);
			}
		});
		newData.data.product_listview.data = productData;
		newData.data.product_listview.fullData = newProductData;
	}
	return newData;
}
